/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  LoginCrmvDto,
  RegistroDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAuthControllerRegistrarUrl = () => {




  return `/v1/auth/registro`
}

/**
 * @summary Cria conta, tenant INDIVIDUAL e cargo Médico na mesma transação
 */
export const authControllerRegistrar = async (registroDto: RegistroDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAuthControllerRegistrarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registroDto)
  }
);}





export const getAuthControllerRegistrarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRegistrar>>, TError,{data: RegistroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRegistrar>>, TError,{data: RegistroDto}, TContext> => {

const mutationKey = ['authControllerRegistrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRegistrar>>, {data: RegistroDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRegistrar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRegistrarMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRegistrar>>>
    export type AuthControllerRegistrarMutationBody = RegistroDto
    export type AuthControllerRegistrarMutationError = ErroResponse

    /**
 * @summary Cria conta, tenant INDIVIDUAL e cargo Médico na mesma transação
 */
export const useAuthControllerRegistrar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRegistrar>>, TError,{data: RegistroDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRegistrar>>,
        TError,
        {data: RegistroDto},
        TContext
      > => {
      return useMutation(getAuthControllerRegistrarMutationOptions(options), queryClient);
    }
    export const getAuthControllerEntrarPorCrmvUrl = () => {




  return `/v1/auth/sign-in/crmv`
}

/**
 * @summary Login por CRMV + UF. Nunca devolve o e-mail.
 */
export const authControllerEntrarPorCrmv = async (loginCrmvDto: LoginCrmvDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAuthControllerEntrarPorCrmvUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginCrmvDto)
  }
);}





export const getAuthControllerEntrarPorCrmvMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>, TError,{data: LoginCrmvDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>, TError,{data: LoginCrmvDto}, TContext> => {

const mutationKey = ['authControllerEntrarPorCrmv'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>, {data: LoginCrmvDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerEntrarPorCrmv(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerEntrarPorCrmvMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>>
    export type AuthControllerEntrarPorCrmvMutationBody = LoginCrmvDto
    export type AuthControllerEntrarPorCrmvMutationError = ErroResponse

    /**
 * @summary Login por CRMV + UF. Nunca devolve o e-mail.
 */
export const useAuthControllerEntrarPorCrmv = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>, TError,{data: LoginCrmvDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerEntrarPorCrmv>>,
        TError,
        {data: LoginCrmvDto},
        TContext
      > => {
      return useMutation(getAuthControllerEntrarPorCrmvMutationOptions(options), queryClient);
    }
    export const getAuthControllerHandoffWebUrl = () => {




  return `/v1/auth/handoff-web`
}

/**
 * @summary Token de uso único para abrir o site já autenticado (app).
 */
export const authControllerHandoffWeb = async ( options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAuthControllerHandoffWebUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthControllerHandoffWebMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerHandoffWeb>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerHandoffWeb>>, TError,void, TContext> => {

const mutationKey = ['authControllerHandoffWeb'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerHandoffWeb>>, void> = () => {


          return  authControllerHandoffWeb(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerHandoffWebMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerHandoffWeb>>>

    export type AuthControllerHandoffWebMutationError = ErroResponse

    /**
 * @summary Token de uso único para abrir o site já autenticado (app).
 */
export const useAuthControllerHandoffWeb = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerHandoffWeb>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerHandoffWeb>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerHandoffWebMutationOptions(options), queryClient);
    }
